<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { cardProps } from './card'

defineOptions({
  name: 'VsCard',
})

const props = defineProps(cardProps)

// init here
</script>
